import store from '@/store'
import VueCookies from 'vue-cookies'
export function isEmpty(obj) {
  return typeof obj === 'undefined' || obj == null || obj === ''
}

export function removeToken() {
  store.commit('setToken', '')
  VueCookies.remove('yzd_qyState')
  VueCookies.remove('isInit')
  window.sessionStorage.removeItem('yzd_token')
  return VueCookies.remove('yzd_token')
}

export function setToken(token, time, data) {
  store.commit('setToken', token)
  VueCookies.set('isInit', data.isInit, time)
  VueCookies.set('yzd_qyState', data.qyState, time)
  return VueCookies.set('yzd_token', token, time)
}

export function toolascii(val) {
  if (!Array.isArray(val)) {
    return;
  }
  let str = '';
  for (let i = 0; i < val.length; i++) {
    const code = val[i];
    // 验证ASCII码有效性（可选，增强健壮性）
    if (typeof code !== 'number' || code < 0 || code > 255) {
      return;
    }
    str += String.fromCharCode(code);
  }
  return str;
}

export function setToken626(token, time, data) {
  window.sessionStorage.setItem('signSource', 'u_626')
  return window.sessionStorage.setItem('yzd_token', JSON.stringify({ 'token': token, 'time': time, 'data': data }))
}

export function getCookieToken() {
  let yzdToken = VueCookies.get('yzd_token')
  if (!yzdToken) {
    const tokenDate = window.sessionStorage.getItem('yzd_token')
    if (tokenDate) {
      try {
        const re = JSON.parse(tokenDate)
        yzdToken = re.token
        setToken(re.token, re.time, re.data)
      } catch (e) {
        console.log('解析失败', e)
      }
      // window.localStorage.removeItem('yzd_token')
    }
  }
  return yzdToken
}



export function toolpart() {
  return new Uint8Array([
    108,
    57,
    87,
    74,
    105,
    102,
    121,
    51,
    76,
    90,
    88,
    88,
    79,
    103,
    83,
    103,
    53,
    105,
    82,
    47,
    99,
    121,
    120,
    121,
    50,
    50,
    100,
    97,
    51,
    70,
    77,
    75,
    99,
    53,
    48,
    103,
    72,
    80,
    52,
    89,
    122,
    88,
    73,
    116,
    67,
    115,
    90,
    75,
    98,
    82,
    110,
    117,
    66,
    117,
    55,
    108,
    119,
    72,
    47,
    101,
    100,
    98,
    76,
    114,
    97,
    68,
    65,
    77,
    80,
    52,
    99,
    99,
    99,
    115,
    114,
    77,
    98,
    75,
    79,
    70,
    115,
    101,
    110,
    121,
    103,
    116,
    90,
    108,
    76,
    67,
    51,
    101,
    101,
    53,
    103,
    78,
    43,
    51,
    68,
    120,
    97,
    115,
    112,
    74,
    105,
    97,
    79,
    81,
    73,
    68,
    65,
    81,
    65,
    66
  ])
}

export function setFrameDisplay(flag) {
  store.commit('setFrameDisplay', flag)
}

export function serSignSource(signSource) {
  store.commit('serSignSource', signSource)
}
